import { IonButton, IonFab, IonIcon } from "@ionic/react";
import { add } from "ionicons/icons";

export const CreateFileTypeButton = () => {
  return (
    <IonFab vertical="bottom" horizontal="end" slot="fixed">
      <IonButton routerLink={`/app/tic/tipos-de-archivos/crear`} color="secondary" size="default">
        <IonIcon icon={add} slot="start" />
        <span>Crear tipo de archivo</span>
      </IonButton>
    </IonFab>
  );
};
